import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// FR locales
import frCommon from './locales/fr/common.json';
import frLanding from './locales/fr/landing.json';
import frProducts from './locales/fr/products.json';
import frCart from './locales/fr/cart.json';
import frCheckout from './locales/fr/checkout.json';
import frErrors from './locales/fr/errors.json';
// EN locales
import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enProducts from './locales/en/products.json';
import enCart from './locales/en/cart.json';
import enCheckout from './locales/en/checkout.json';
import enErrors from './locales/en/errors.json';
const STORAGE_KEY = 'lpc.lang';
export function getStoredLanguage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw === 'en' || raw === 'fr')
            return raw;
    }
    catch {
        /* ignore - SSR / private browsing */
    }
    const nav = navigator.language.slice(0, 2).toLowerCase();
    return nav === 'en' ? 'en' : 'fr';
}
export function persistLanguage(lang) {
    try {
        localStorage.setItem(STORAGE_KEY, lang);
    }
    catch {
        /* ignore */
    }
}
void i18n.use(initReactI18next).init({
    resources: {
        fr: {
            common: frCommon,
            landing: frLanding,
            products: frProducts,
            cart: frCart,
            checkout: frCheckout,
            errors: frErrors,
        },
        en: {
            common: enCommon,
            landing: enLanding,
            products: enProducts,
            cart: enCart,
            checkout: enCheckout,
            errors: enErrors,
        },
    },
    lng: getStoredLanguage(),
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    defaultNS: 'common',
    ns: ['common', 'landing', 'products', 'cart', 'checkout', 'errors'],
    interpolation: { escapeValue: false },
    returnNull: false,
});
// RTL hook placeholder - activate when Arabic is added
i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
    document.documentElement.dir = i18n.dir(lng);
});
export default i18n;
